export enum SocketNotificationType {
    BookingCreated = "booking-created",
    GTPBookingCreated = "gtp-booking-created",
    GroupBookingCreated = "group-booking-created",
    BookingInvite = "booking-invite",
    BookingStart = "booking-start",
    BookingStarted = "booking-started",
    BookingEnded = "booking-ended",
    CoffeeCallCreated = "coffee-call-created",
    CoffeeCallStarted = "coffee-call-started",
    CoffeeCallAccepted = "coffee-call-accepted",
    CoffeeCallRejected = "coffee-call-rejected",
    CoffeeCallEnded = "coffee-call-ended",
    TalentBookingAccepted = "talent-booking-accepted",
    TalentBookingRejected = "talent-booking-rejected",
    GTPBookingAccepted = "gtp-booking-accepted",
    GTPBookingRejected = "gtp-booking-rejected",
    BookingAcceptedInvite = "booking-accepted-invite",
    BookingRejectedInvite = "booking-rejected-invite",
    GTPMemberInvite = "gtp-member-invite",
    GTPCardCreated = "gtp-card-created",
    AdminNotification = "admin-notification",
    PVLCStatus = "pvlc-status",
    CardWhiteboardStarted = "card-whiteboard-started",
    BingoSessionCreated = "bingo-session-created",
    BingoSessionStarted = "bingo-session-started",
    BingoSessionEnded = "bingo-session-ended",
    BingoSessionReset = "bingo-session-reset",
    BingoPlayerJoined = "bingo-player-joined",
    BingoCellMarked = "bingo-cell-marked",
    BingoWinnerAnnounced = "bingo-winner-announced",
    CardQuestionCreated = "card-question-created",
    CardAnswerCreated = "card-answer-created",
    CloverTicketPurchased = "clover-ticket-purchased",
    DiamondProductPurchased = "diamond-product-purchased",
    BusinessTalentInvited = "business-talent-invited",
    BusinessTalentAccepted = "business-talent-accepted",
    BusinessTalentRejected = "business-talent-rejected",
    BusinessTalentRevoked = "business-talent-revoked",
    InstantSessionRequested = "instant-session-requested",
    InstantSessionResponded = "instant-session-responded",
    InstantSessionStarted = "instant-session-started",
    InstantSessionUserJoined = "instant-session-user-joined",
    InstantSessionEnded = "instant-session-ended",
    InstantCardReviewCreated = "instant-card-review-created",
    InstantCardTipReceived = "instant-card-tip-received",
    FlashCardBooking = "flash-card-booking",
    FlashCardEnded = "flash-card-ended",
    FlashCardStarted = "flash-card-started",
    FlashCardUserJoined = "flash-card-user-joined",
    FlashCardBookingRefund = "flash-card-booking-refund",
    FlashCardCancelled = "flash-card-cancelled",
    StaiSessionPurchased = "stai-session-purchased",
    StaiSessionPermanentPurchased = "stai-session-permanent-purchased",
    StaiReaction = "stai-reaction",
    StaiComment = "stai-comment",
    StaiCommentReply = "stai-comment-reply",
    StaiSessionStarted = "stai_session_started",
    StaiSessionEnded = "stai_session_ended",
    StaiNewPost = "stai-new-post",
    StaiSessionLive = "stai-session-live",
    StaiAppreciation = "stai-post-tip",
    GiftCardRequestAccepted = "gift-card-request-accepted",
    GiftCardRequestRejected = "gift-card-request-rejected",
    GiftCardRequestCompleted = "gift-card-request-completed",
    GiftCardRequestCreated = "gift-card-request-created",
    SnapFlyerRequestCreated = "snap-flyer-request-created",
    SnapFlyerRequestAccepted = "snap-flyer-request-accepted",
    SnapFlyerRequestRejected = "snap-flyer-request-rejected",
    DearCardRequestCreated = "dear-card-request-created",
    DearCardRequestAccepted = "dear-card-request-accepted",
    DearCardRequestRejected = "dear-card-request-rejected",
    StaiPostSessionStarted = "stai-post-session-started",
    StaiPostSessionEnded = "stai-post-session-ended",
    StaiMomentJoined = "stai-moment-joined",
    StaiMomentLeft = "stai-moment-left",
    BMCardPurchased = "bm-card-purchased",
    BMContentCreated = "bm-content-created",
    BMContentApproved = "bm-content-approved",
    BMContentRejected = "bm-content-rejected",
    NewExpAdded = "new-exp-added",
    DemoCardExpReaction = "demo-card-exp-reaction",
    DemoCardExpComment = "demo-card-exp-comment",
    DemoCardExpCommentReplied = "demo-card-exp-comment-replied",
    SingleCardExpReaction = "single-card-exp-reaction",
    SingleCardExpComment = "single-card-exp-comment",
    SingleCardExpCommentReplied = "single-card-exp-comment-replied",
    OnAtticStoreUpdate = "on-attic-store-update",
    AtticStoreUpdate = "attic-store-update",
    MainCardPageReaction = "main-card-page-reaction",
    MainCardPageTip = "main-card-page-tip",
    MainCardPageComment = "main-card-page-comment",
    MainCardPageCommentReplied = "main-card-page-comment-replied",
    GiftReceived = 'gift-received',
      TalentGiftReaction = 'talent-gift-reaction',
      TalentGiftReply = 'talent-gift-reply',
  }
  
  export enum NotificationType {
    Announcement = "Announcement",
    Alert = "Alert",
    General = "General",
    BookingInvite = "booking_invite",
    BookingAccepted = "booking_accepted",
    BookingRejected = "booking_rejected",
    GroupSession = "group_session",
    RegularSession = "regular_session",
    GTPInvitation = "gtp_invitation",
    GTPMemberRemoved = "gtp_member_removed",
    StageCardBooked = "stage_card_booked",
    StageCardAccepted = "stage_card_accepted",
    BookingCreated = "booking_created",
    GTPBookingCreated = "gtp_booking_created",
    DirectMessage = "direct_message",
    PerformerInvite = "performer_invite",
    InviteAccepted = "invite_accepted",
    InviteRejected = "invite_rejected",
    ModeratorInvite = "moderator_invite",
    ModeratorInviteAccepted = "moderator_invite_accepted",
    ModeratorInviteRejected = "moderator_invite_rejected",
    CloverTicketPurchased = "clover_ticket_purchased",
    DiamondCardPurchased = "diamond_card_purchased",
    DiamondCardProductPurchased = "diamond_card_product_purchased",
    CardQuestionCreated = "card_question_created",
    CardAnswerCreated = "card_answer_created",
    CardReviewCreated = "card_review_created",
    AceCardPurchased = "ace_card_purchased",
    FanCardPurchased = "fan_card_purchased",
    PremiumCardPurchased = "premium_card_purchased",
    PremiumContentPurchased = "premium_content_purchased",
    BusinessTalentInvite = "business_talent_invite",
    BusinessTalentRevoked = "business_talent_revoked",
    BusinessTalentInviteAccepted = "business_talent_invite_accepted",
    BusinessTalentInviteRejected = "business_talent_invite_rejected",
    GtpInviteAccepted = "gtp_invite_accepted",
    GtpInviteRejected = "gtp_invite_rejected",
    CoffeeCallRejected = "coffee_call_rejected",
    AceLoungeBookingInvite = "ace_lounge_booking_invite",
    AceLoungeBookingAccepted = "ace_lounge_booking_accepted",
    AceLoungeBookingRejected = "ace_lounge_booking_rejected",
    AceLoungeGroupSession = "ace_lounge_group_session",
    AceLoungeBookingCreated = "ace_lounge_booking_created",
    AceLoungeRegularSession = "ace_lounge_regular_session",
    CoreCardBookingCreated = "core_card_booking_created",
    CoreCardPurchased = "core_card_purchased",
    CoreCardBookingAccepted = "core_card_booking_accepted",
    CoreCardBookingRejected = "core_card_booking_rejected",
    CoreCardSession = "core_card_session",
    InstantSessionRequested = "instant_session_requested",
    InstantSessionResponded = "instant_session_responded",
    InstantCardReviewCreated = "instant_card_review_created",
    InstantSessionStarted = "instant_session_started",
    InstantSessionEnded = "instant_session_ended",
    InstantCardTipReceived = "instant_card_tip_received",
    CloverCardStarted = "clover_card_started",
    CloverCardCreated = "clover_card_created",
    CoffeeCallCreated = "coffee_call",
    StageCard = "stage_card",
    FlashCardBooking = "flash_card_booking",
    FlashCardBookingRefund = "flash_card_booking_refund",
    FlashCardCancelled = "flash_card_booking_refund",
    FlashCardStarted = "flash_card_started",
    StaiSessionPurchased = "stai_session_purchased",
    StaiSessionPermanentPurchased = "stai_session_permanent_purchased",
    StaiReaction = "stai_reaction",
    StaiComment = "stai_comment",
    StaiCommentReply = "stai_comment_reply",
    StaiSessionStarted = "stai_session_started",
    StaiSessionEnded = "stai_session_ended",
    StaiNewPost = "stai_new_post",
    StaiSessionLive = "stai_session_live",
    GiftCardRequestAccepted = "gift_card_request_accepted",
    GiftCardRequestRejected = "gift_card_request_rejected",
    GiftCardRequestCompleted = "gift_card_request_completed",
    GiftCardRequestCreated = "gift_card_request_created",
    GiftCardSent = "gift_card_sent",
    SnapFlyerRequestCreated = "snap_flyer_request_created",
    SnapFlyerRequestAccepted = "snap_flyer_request_accepted",
    SnapFlyerRequestRejected = "snap_flyer_request_rejected",
    BMCardPurchased = "bm_card_purchased",
    BMContentCreated = "bm_content_created",
    BMContentApproved = "bm_content_approved",
    BMContentRejected = "bm_content_rejected",
    GiftReceived = 'gift_received',
      TalentGiftReply = 'talent_gift_reply',
      TalentGiftReaction = 'talent_gift_reaction'
  }